import { useState } from "react";
import { t } from "@/i18n-js/instance";
import { DownloadCSV } from "./DownloadCSV";
import { Participant } from "./Participant";
import { SearchParticipants } from "./SearchParticipant";
import { SortParticipants } from "./SortParticipant";
import { useDownloadCSV } from "./hooks/useDownloadCSV";
import { useParticipants } from "./hooks/useParticipants";

interface ParticipantsProps {
  participantsCount: number;
  roomId: string;
}
export const Participants = ({
  roomId,
  participantsCount,
}: ParticipantsProps) => {
  const { records, isLoading } = useParticipants(roomId);
  const [searchText, setSearchText] = useState("");
  const [shouldEnableAscendingSort, setShouldEnableAscendingSort] =
    useState(false);
  const { onDownloadCSV } = useDownloadCSV(roomId);

  const onSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  };

  const onClickSort = (sortDirection: boolean) => {
    setShouldEnableAscendingSort(!sortDirection);
  };

  let participants =
    (records &&
      records.filter(participant =>
        participant.name.toLowerCase().includes(searchText.toLocaleLowerCase()),
      )) ||
    [];

  if (shouldEnableAscendingSort) {
    participants = participants.sort((a, b) => b.name.localeCompare(a.name));
  } else {
    participants = participants.sort((a, b) => a.name.localeCompare(b.name));
  }

  return (
    <div className="text-dark absolute inset-x-9 bottom-0 top-[114px] flex flex-col pb-4 pt-1.5 text-sm font-normal">
      <div className="border-primary mb-6 flex items-center justify-between border-b-[1px] pb-1.5">
        <SearchParticipants onSearchChange={onSearchChange} />
        <SortParticipants onClickSort={onClickSort} />
        <DownloadCSV onClickDownload={onDownloadCSV} />
      </div>
      {!isLoading && (
        <>
          <div className="text-darkest mb-6 text-base font-semibold">
            {t("live_streams.dashboard.participants.participant_count", {
              count: participantsCount,
            })}
          </div>
          {participants && participants.length > 0 && (
            <div className="grow overflow-auto">
              {participants.map(record => (
                <Participant key={record.id} record={record} />
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};
